import { createContext, useContext } from 'react';

export type MutationSignal = {
  kind: 'create' | 'update' | 'delete';
  resourceName: string;
  displayName?: string;
};

export type MutationSignalHandler = (signal: MutationSignal) => void;

const noopHandler: MutationSignalHandler = () => {};

export const MutationSignalContext =
  createContext<MutationSignalHandler>(noopHandler);

export const useMutationSignal = () => useContext(MutationSignalContext);
